var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetodologyEagle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 99,
    viewBox: "0 0 105 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.4922 68.2246C59.815 72.2059 66.7346 79.3547 66.7346 84.2959C66.7346 89.1387 59.6996 88.9572 59.6996 88.9572",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5057 88.9568C44.5057 88.9568 37.4707 89.1384 37.4707 84.2956C37.4707 79.5559 44.4303 72.2994 48.75 68.252",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41322 66.629L7.5918 63.9307",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0733 79.4704L14.0059 73.4385",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0266 92.7441L23.8438 88.0244",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7784 69.3655C15.423 67.1349 13.3262 65.615 11.0956 65.9719C8.86498 66.3272 7.34661 68.424 7.70197 70.6547C8.05734 72.8853 10.1541 74.4037 12.3848 74.0483C14.6154 73.6914 16.1353 71.5946 15.7784 69.3655Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6485 84.5706C59.2854 86.4243 59.6484 88.4334 59.6484 90.3072C59.6484 92.064 58.3085 93.0562 56.9532 93.6085C54.8995 94.4469 53.1996 95.973 52.1058 97.9052L52.1027 97.9113C51.0074 95.9776 49.3045 94.45 47.2477 93.6116C45.8939 93.0593 44.5586 92.0686 44.5586 90.3072C44.5586 84.6013 47.9368 77.6279 52.1043 77.6279C53.0412 77.6279 53.938 77.9802 54.7641 78.5909",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5127 65.2549C36.4499 65.2549 33.1562 67.9086 33.1562 71.1822C33.1562 74.4559 36.4499 77.1095 40.5127 77.1095",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1456 65.2891C40.5472 66.0936 40.1934 67.0905 40.1934 68.1704C40.1934 70.5134 41.8594 72.4656 44.0716 72.9086",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8457 79.2414L33.705 73.874",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9303 79.5859L25.7188 84.1995",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9371 84.7161C17.9172 84.8792 16.8573 84.4131 16.3096 83.4639C15.6004 82.2363 16.0204 80.6671 17.248 79.9579L19.5432 78.6319C20.7709 77.9227 22.34 78.3427 23.0492 79.5703C23.7584 80.7979 23.3384 82.3686 22.1108 83.0762L19.8155 84.4023C19.5356 84.5653 19.2371 84.6684 18.9371 84.7161Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1018 83.084C23.3295 82.3748 24.9001 82.7948 25.6078 84.0224C26.317 85.25 25.897 86.8192 24.6694 87.5284L22.3741 88.8544C22.0941 89.016 21.7972 89.119 21.4957 89.1667C20.4758 89.3298 19.4159 88.8637 18.8682 87.9145C18.159 86.6869 18.579 85.1162 19.8066 84.4085",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8107 84.1991C92.6905 83.2254 94.7642 80.4994 94.7642 77.2903C94.7642 73.2644 91.4998 70 87.4739 70C83.448 70 80.1836 73.2644 80.1836 77.2903C80.1836 78.2964 80.3867 79.2548 80.7559 80.1255",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6895 65.2549C67.7523 65.2549 71.0444 67.9086 71.0444 71.1822C71.0444 74.4559 67.7507 77.1095 63.6895 77.1095",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0549 65.2881C63.6533 66.0927 64.0071 67.0895 64.0071 68.1695C64.0071 70.4939 62.3657 72.4338 60.1797 72.8969",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4681 79.4083L70.4395 73.8486",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2715 79.5859L78.926 84.8795",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5531 86.3544C83.4808 87.3851 84.0393 88.4005 85.0315 88.862C86.3176 89.4604 87.8436 88.902 88.4421 87.6174L89.5605 85.2145C90.1589 83.93 89.6005 82.4024 88.3159 81.8039C87.0298 81.2055 85.5038 81.7624 84.9054 83.0485L83.787 85.4514C83.6516 85.7452 83.5747 86.0514 83.5531 86.3544Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9003 83.058C85.4987 81.7735 84.9403 80.2459 83.6558 79.6474C82.3697 79.049 80.8436 79.6074 80.2452 80.892L79.1268 83.2949C78.9899 83.5887 78.9145 83.8933 78.893 84.1979C78.8207 85.2286 79.3791 86.244 80.3713 86.7055C81.6559 87.3039 83.1835 86.7455 83.7819 85.4609",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0347 10.5358H47.1707L46.0015 8.399C44.9693 6.5145 46.1292 4.17772 48.2537 3.86081C48.7291 3.79005 49.2137 3.83005 49.6705 3.97927C51.2505 4.49616 52.9534 4.49616 54.5333 3.97927C54.9902 3.83005 55.4748 3.78851 55.9502 3.86081C58.0747 4.17772 59.2346 6.5145 58.2039 8.399L57.0347 10.5358Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8926 25.7607L37.101 39.083",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68413 27.7181C8.58112 24.0491 8.4719 20.0493 9.55183 16.1295C10.0149 14.445 12.1255 13.8928 13.3562 15.1327L18.822 20.6447",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3563 41.5722C5.13974 38.7478 1.52919 33.3835 1.13537 27.1501C1.03076 25.484 2.76604 24.3287 4.26287 25.0656L37.0809 41.2461",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9939 53.189C10.8589 53.6012 4.8731 50.3938 1.91021 44.7295C1.09026 43.1634 2.27172 41.2974 4.03777 41.3651L37.0973 42.6604",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7683 60.4138C23.4456 62.649 17.166 62.049 12.2801 58.4477C11.0817 57.5647 11.2863 55.7171 12.6493 55.1172L37.0678 44.3701",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9979 66.5015C33.558 68.1153 30.6351 68.8045 25.92 67.9799C24.4355 67.6538 23.8586 65.8447 24.8801 64.7186L37.067 51.2979",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5424 27.6483C95.6255 23.9993 95.7255 20.0241 94.6547 16.1305C94.1917 14.446 92.0811 13.8937 90.8504 15.1337L67.1426 39.0445",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M102.425 30.8991C102.768 29.696 102.988 28.4423 103.07 27.1501C103.174 25.484 101.439 24.3287 99.9422 25.0656L67.1211 41.2477",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8281 41.5827C95.8757 40.4782 97.6756 38.9814 99.1324 37.1953",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2071 53.187C93.3422 53.6008 99.3295 50.3933 102.294 44.7275C103.114 43.1615 101.932 41.2954 100.166 41.3631L67.1191 42.6584",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4421 60.4148C80.7649 62.6485 87.0414 62.0485 91.9273 58.4472C93.1257 57.5642 92.9211 55.7166 91.5581 55.1166L67.1211 44.3604",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4421 66.6584C70.9989 68.2629 73.968 68.8028 78.2846 67.9798C79.7691 67.6537 80.346 65.8446 79.3246 64.7185L67.1191 51.2793",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4844 18.6331L44.4904 17.7763C47.2549 16.5963 48.3717 13.2919 47.1718 10.5352",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1184 18.6338L35.3277 15.2448C34.997 13.828 36.0723 12.4727 37.5276 12.4727H41.0751C42.5304 12.4727 43.6057 13.828 43.2749 15.2448L42.4842 18.6338",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3008 12.2668V9.96387",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1029 35.8718V30.1321C52.1029 23.7817 46.954 18.6328 40.6036 18.6328H37.6992C33.8748 18.6328 31.075 22.2372 32.021 25.9431H36.7992C40.6051 25.9431 43.1896 29.8121 41.7312 33.3273L40.6867 35.8456",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7212 18.6331L59.7152 17.7763C56.9507 16.5963 55.8354 13.2919 57.0353 10.5352",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0877 18.6338L68.8784 15.2448C69.2092 13.828 68.1339 12.4727 66.6786 12.4727H63.1311C61.6758 12.4727 60.6005 13.828 60.9312 15.2448L61.722 18.6338",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9043 12.2668V9.96387",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1016 30.1321C52.1016 23.7817 57.2505 18.6328 63.6009 18.6328H66.5053C70.3297 18.6328 73.1295 22.2372 72.1834 25.9431H67.4052C63.5993 25.9431 61.0149 29.8121 62.4732 33.3273L63.5286 35.8718",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4727 67.6211V69.9456",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0066 65.2532C60.393 65.2455 56.9209 66.6654 54.3487 69.2037L52.1027 71.4205L49.8567 69.2037C47.2846 66.6638 43.814 65.2439 40.1988 65.2532C38.4943 65.2578 37.1113 63.8763 37.1113 62.1733V38.9763C37.1113 37.2749 38.4897 35.8965 40.1911 35.8965H64.0112C65.7127 35.8965 67.091 37.2749 67.091 38.9763V62.1733C67.0941 63.8779 65.7096 65.2578 64.0066 65.2532Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2715 47.2917V42.0566H60.9319V59.1002C57.606 59.0879 54.4385 60.5232 52.254 63.0323L52.1017 63.2077L51.9494 63.0323C49.7665 60.5232 46.599 59.0879 43.2715 59.1002V54.4713",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1016 4.36483V1.91113",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetodologyEagle);
export default __webpack_public_path__ + "static/media/metodology-eagle.dcc876619b59a95d04bd79dc9f6b8c4e.svg";
export { ForwardRef as ReactComponent };